import Navbar from "@/layout/Navbar.vue";
import Sidebar from "@/layout/Sidebar.vue";

const monitoringHubRoutes = [

    {
        path: "/fodsa-users",
        name: "FodsaUsers",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "FodsaUsers" */ "@/views/SubSystems/MonitoringHub/FodsaUsers.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },
    {
        path: "/urban-waste-quantities",
        name: "UrbanWasteQuantities",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "UrbanWasteQuantities" */ "@/views/SubSystems/MonitoringHub/UrbanWasteQuantities.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },
    {
        path: "/landfilling-waste-quantities",
        name: "LandfillingWasteQuantities",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "LandfillingWasteQuantities" */ "@/views/SubSystems/MonitoringHub/LandfillingWasteQuantities.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },
    {
        path: "/recycled-quantities-report",
        name: "RecycledQuantitiesReport",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "RecycledQuantitiesReport" */ "@/views/SubSystems/MonitoringHub/RecycledQuantitiesReport.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },
    {
        path: "/total-recycled-landfilling-quantities-report",
        name: "TotalRecycledAndLandfillingWasteQuantities",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "TotalRecycledAndLandfillingWasteQuantities" */ "@/views/SubSystems/MonitoringHub/TotalRecycledAndLandfillingWasteQuantities.vue"
                ),
        },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/sanitary-landfill-reports/:id",
        name: "SanitaryLandfillReports",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "SanitaryLandfillReports" */ "@/views/SubSystems/MonitoringHub/SanitaryLandfillReports.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: true,
        },
    },

    {
        path: "/sanitary-landfill-reports-log/:id",
        name: "SanitaryLandfillReportsLog",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "SanitaryLandfillReportsLog" */ "@/views/SubSystems/MonitoringHub/SanitaryLandfillReportsLog.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: false,
        },
    },

    {
        path: "/sanitary-landfill-reports/:id/sanitary-landfill-report",
        name: "SanitaryLandfillReport",
        components: {
            topbar: Navbar,
            sidebar: Sidebar,
            main: () =>
                import(
                    /* webpackChunkName: "SanitaryLandfillReports" */ "@/views/SubSystems/MonitoringHub/SanitaryLandfillReport.vue"
                ),
        },
        props: { main: true },
        meta: {
            authentication: true,
        },
    },
]

export default monitoringHubRoutes